var map = {
	"./dark/status/06sleep/01info.svg": "4T4/",
	"./light/status/06sleep/01info.svg": "vkCy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+YIz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/status\/06sleep\/01info\.svg$
// module id = +YIz
// module chunks = 0